import { IOptions } from 'components/shared/FormAdapters/FormDefault/InlineSelect/types';

export const doesOptionsKeyIncludePart = (key: keyof IOptions) => (option: IOptions, part: string) =>
  option[key]?.toString().toLowerCase().includes(part);

export const doesOptionContainPart = (
  option: IOptions,
  part: string,
  flags: { checkInLabel?: boolean; checkInValue?: boolean } = { checkInLabel: true, checkInValue: true },
) => {
  const labelContainsPart = doesOptionsKeyIncludePart('label')(option, part);
  const valueContainsPart = doesOptionsKeyIncludePart('value')(option, part);

  return (flags.checkInLabel && labelContainsPart) || (flags.checkInValue && valueContainsPart);
};

export function searchInOptions(
  options: IOptions[],
  search: string,
  {
    sort: sortingEnabled = true,
    filter: filteringEnabled = true,
    filterLabel: filteringByLabelEnabled = true,
    filterValue: filteringByValueEnabled = true,
    searchInLabel = true,
    searchInValue = true,
    filterFn,
  }:
    | {
        sort?: boolean;
        filter?: boolean;
        filterLabel?: boolean;
        filterValue?: boolean;
        searchInLabel?: boolean;
        searchInValue?: boolean;
        filterFn?: (option: IOptions) => boolean;
      }
    | undefined = {},
) {
  const searchLower = search.toLowerCase();
  const letters = searchLower.split('');

  const filtered = filteringEnabled
    ? options.filter((option) =>
        filterFn
          ? filterFn(option)
          : letters.every((letter) =>
              doesOptionContainPart(option, letter, {
                checkInLabel: filteringByLabelEnabled,
                checkInValue: filteringByValueEnabled,
              }),
            ),
      )
    : options;

  const sorted = sortingEnabled
    ? [...filtered].sort(
        (a, b) =>
          Number(doesOptionContainPart(b, searchLower, { checkInLabel: searchInLabel, checkInValue: searchInValue })) -
          Number(doesOptionContainPart(a, searchLower, { checkInLabel: searchInLabel, checkInValue: searchInValue })),
      )
    : filtered;

  return sorted;
}
